import { useFormState } from 'react-hook-form';

interface Props {
    children: any;
}

const FormStateConsumer = ({ children }: Props) => {
    const formState = useFormState();

    return children(formState);
};

export default FormStateConsumer;
